import { useMemo, useContext } from 'react';
import { CanUploadFilesContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context';
import { useDevice } from '@trinity/chat-components/hooks/useDevice';

export const useCanUpload = () => {
  const canUpload = useContext(CanUploadFilesContext);

  const device = useDevice();
  return useMemo(() => canUpload && !device.phone && !device.tablet, [canUpload, device]);
};
